
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chhatrapati Sambhaji Nagar FIDE Rapid Rating Chess Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">

        <div class="row justify-content-between">
            <div class="col-md-7">

                <p><strong>Chhatrapati Sambhaji Nagar, March 2, 2025:</strong> FM Akash Dalvi of Maharashtra emerged victorious at the 1st G.H. Raisoni Memorial Chhatrapati Sambhaji Nagar FIDE Rapid Rating Chess Tournament. The prestigious event, organized by G.H. Raisoni Sports and Cultural Foundation in collaboration with Kalpana Prakash Welfare Foundation and the Aurangabad District Chess Association, took place at Himalaya Public School, Beed Bypass Road. The tournament was officially recognized by the Maharashtra Chess Association, the All India Chess Federation, and FIDE.
                </p>
                <h6>Tournament Highlights: </h6>
                <ul class="list-style list-style1">
                  <li><strong>Participants : </strong> 324 players from across India, including two International Masters – IM Kushagra Mohan and IM Ravi Teja.</li>
                  <li><strong>Champion : </strong> FM Akash Dalvi secured the title with 8.5 points out of 9 games, winning a cash prize of ₹50,000 and a prestigious trophy.</li>
                  <li><strong>Runner-Up : </strong> IM Kushagra Mohan (Telangana) finished second with 8 points, earning ₹30,000.</li>
                  <li><strong>Third Place : </strong> FM Gaurang Bagwe (Maharashtra) also scored 8 points but was placed third based on tie-break scores.</li>
                  <li><strong>Top 8 Finishers : </strong>
                    <ul class="list-style1 list-count">
                      <li>FM Akash Dalvi – 8.5 points</li>
                      <li>IM Kushagra Mohan – 8 points</li>
                      <li>FM Gaurang Bagwe – 8 points</li>
                      <li>FM Suyog Wagh – 7.5 points</li>
                      <li>Vedant Pimpalkhare – 7.5 points</li>
                      <li>FM Vedant Panesar – 7.5 points</li>
                      <li>Priyanshu Patil – 7.5 points</li>
                      <li>Vaibhav Raut – 7.5 points</li>
                    </ul>
                  </li>
                </ul>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/fide-rapid-rating-chess-tournament.webp"
                        alt="GHRSCF" />

                </div>
            </div>
        </div>
        <h6>Prize Distribution Ceremony:</h6>
      <p>  The winners were felicitated by Chief Guest Shri Arvind Dhobale, IRS (Retd.), Assistant
        Commissioner, Central GST, in the presence of esteemed dignitaries:</p>
      <ul class="list-style">
        <li> Shri Deelip Wakode, General Manager, Crompton Greaves Limited</li>
        <li>Shri Hemendra Patel, Secretary, Aurangabad District Chess Association</li>
        <li>Shri Bhushan Shriwas, Organizing Secretary &amp; Secretary, Kalpana Prakash Welfare Foundation</li>

       <li> IA Ajinkya Pingale, Chief Arbiter</li>
       <li> FA Amrish Joshi, Deputy Chief Arbiter</li>
        <li>Shri S.S. Soman, MCA Observer Committee Member</li>
      </ul>
  <h6>    Special Awards & Categories:</h6>
    <ul class="list-style">
      <li><strong>Cash Prizes:</strong> Top 15 finishers</li>
      <li><strong>Special Awards:</strong> Best Veteran (55+), Best Female (18+), Best Chhatrapati Sambhaji Nagar Player, Best Unrated Player</li>
      <li><strong>Rating Category Prizes:</strong> Best players in the 1400-1600 & 1601-1800 rating categories</li>
      <li><strong>Age-Group Trophies:</strong> Top finishers in Under-7, Under-9, Under-11, Under-13, and Under-15 (boys & girls)</li>

    </ul>
    <h6>Officiating Team:</h6>
<p>The Maharashtra Chess Association appointed IA Ajinkya Pingale (Mumbai) as the Chief Arbiter, supported by:</p>
<ul class="list-style">
  <li>FA Amrish Joshi – Deputy Chief Arbiter</li>
  <li>FA Sagar Sakhare, FA Satish Thakur, FA Amit Tembhurne, FA Vilas Rajput</li>
  <li>SNA Prayas Ambade, SNA Shishir Indurkar, Krishna Thakur, Ketki Deshmukh, Prathamesh Machave, Pushkar Dongre, Abhijit Vaishnav</li>
</ul>
<p>The tournament witnessed intense competition and remarkable performances, further enriching the Indian chess landscape. Congratulations to all participants and winners!</p>

            <section class="section section-md fide-chesscompetition section-banner-bg-1">
                <div class="container">

                    <div class="row row-cols-1 row-cols-md-1">


                        <div class="col">
                            <div class="gall-ery">
                                <div class="row">
                                    <div class="col-md-7">
                                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                                            <h4 class="fw-bold">Photos</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="lightBox--gallery">
                                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament1.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament1.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament1.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament2.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament2.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament2.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament3.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament3.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament3.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament5.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament5.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament5.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="gall-ery">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4 class="fw-bold">Media Coverage</h4>
                                </div>
                                <div class="lightBox--gallery">
                                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-2">

                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-media.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-media.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-media.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img
                                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

    </div>

</section>
